// extracted by mini-css-extract-plugin
export default {"userView":"UserView_userView__Jm87m"};